/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {NetworkResource} from '../../../components/api/resources/resource/network.resource.token';
import {TierResource} from '../../../components/api/resources/resource/tier';



export function tierStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('tiers.tier', TierResource, 'app.adm', 'app/admin');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('tier-route') }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: Object.assign({}, adminResourceItemRouteResolve('tier-edit', 'edit'), {
            tierEnabled: /*@ngInject*/ function($stateParams) {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return adnRouterHelper.services.resource(NetworkResource).get({id: LocalNetworkProfile.getNetworkId()}).$promise.then(function(network) {
                return network.tiers.some(function(tier) {
                  return tier.id === $stateParams.id;
                });
              });
            },
            blockDelete: /*@ngInject*/ function(tierEnabled) {
              return tierEnabled;
            }
          }),
          views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'Tier'));
  }, adnRouterHelper);
}
